import { ElementRef, Injectable, OnDestroy } from '@angular/core'
import { Observable, Subject, fromEvent, of } from 'rxjs'
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators'
import { getParentModalWindow } from '../util/common-utils'

@Injectable({
  providedIn: 'root',
})
export class ModalFocusService implements OnDestroy {
  focus$: Observable<FocusEvent>
  destroySubject$ = new Subject<void>()

  constructor() {
    this.focus$ = fromEvent<FocusEvent>(document, 'focusin').pipe(
      takeUntil(this.destroySubject$),
      distinctUntilChanged(),
    )
  }

  ngOnDestroy(): void {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }

  outsideFocus(element: ElementRef): Observable<FocusEvent> {
    const parentModalWindow = getParentModalWindow(element)

    // Don't create an observable in the event
    // that the element passed in is not a modal
    if (parentModalWindow == null) {
      return of()
    }

    return this.focus$.pipe(
      filter((event: FocusEvent) => !parentModalWindow.contains(event.target)),
    )
  }
}
